import worldMap from '../../core/map';
import DistanceReportInfo from '../../info/DistanceReportInfo';
import authorization from '../../api/authorization';
import { FeaturePermission } from '../../../constants/feature.permission.helper';
import api from '../../api';
import { ContextEnum } from '../../../enuns/context.enum';
import translate from '../../core/tools/translate';

class RoutingAction {

    constructor ({ layer, currentMap, feature }) {
        const {isAuthorized} = authorization;

        const freeRouting = (latLng) => () => {
            const e = { latlng: latLng };
            const mapContext = worldMap.getContext();

            if (mapContext.hasPoint(e.latlng)) return;

            if (mapContext.active()) {
                mapContext.setEndPosition(e);
            } else {
                mapContext.setStartPosition(e);
            }
        };

        const originData = {
            type: 'fromStore',
            name: feature.properties.Nome || feature.properties.Name,
            id: feature.properties.Id
        };

        return {
            check () {
                return worldMap.getContext().active();
            },
            layer,
            map: currentMap,
            icon: 'icon_bubble_routing',
            title: translate('Action.Routing'),
            click () {
                const option = {
                    text: "Roteamento Livre",
                    handler: freeRouting(layer.getLatLng()),
                    hidden: !isAuthorized(FeaturePermission.MAP_ROUTES.freeRouting)
                };
                api.general.log.action(ContextEnum.PinStore, 'Rotas - Google');
                new DistanceReportInfo(originData, [option]);
            }
        };
    }


}

export default RoutingAction;



// WEBPACK FOOTER //
// ./src/scripts/layers/HaloLayer/RoutingAction.js